var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPelletHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5676 45.0198C29.7901 45.8781 30.4791 46.3203 33.1712 46.2553C40.3891 46.0862 45.8644 36.3843 38.5165 29.5566C36.2146 27.4238 30.8175 22.5598 28.8407 20.9992",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9465 6.73249C8.47413 4.91176 4.80649 6.7325 2.98576 10.2049C0.969951 14.0544 1.58127 17.6048 5.33978 21.3633",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9137 37.2296C34.9137 35.8641 33.7824 34.7066 32.4169 34.6416C30.7002 34.5636 29.3215 35.8901 29.3345 37.6068C29.3475 39.7396 31.1032 41.5604 33.236 41.6514C34.3285 41.7034 35.3429 41.3783 36.1492 40.8061C39.2574 37.9059 38.6983 33.146 34.9919 31.0912C31.5585 29.1924 27.2406 31.0001 25.4329 34.4855C23.5602 38.075 25.4721 43.004 28.5543 45.0198",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9922 21.2853L28.645 13.4692C28.8141 13.053 29.6465 10.7511 29.6465 10.7511C31.064 5.53602 27.0584 1.36135 23.1439 1.03622C18.8131 0.685079 15.809 2.88296 13.8192 7.81193L1.49032 36.5014C-2.0731 48.1801 14.8075 53.6162 19.1902 41.5604L25.9922 21.2983V21.2853Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.919 40.9101C12.1806 40.3639 12.8049 38.8813 12.3367 37.6068C11.7385 35.9942 9.98276 35.2399 8.40913 35.9161C6.44535 36.7615 5.4567 39.0764 6.19799 41.0922C6.57514 42.1196 7.2647 42.9259 8.11004 43.4461C11.3613 45.2149 15.7828 43.9664 16.264 38.7643C16.6282 34.8627 13.663 31.4293 9.76141 31.1172C5.72979 30.7921 2.62183 33.6662 1.26929 37.2687",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7383 26.3183L13.7151 21.2203",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6672 30.3239L17.9027 27.2287",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7976 12.8449L18.6052 8.64423",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0242 17.8128L22.4415 14.5225",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPelletHeating);
export default __webpack_public_path__ + "static/media/pelletHeating.32783d47154411a5a85aaf0723022afb.svg";
export { ForwardRef as ReactComponent };